export const VEHICLE_CATEGORIES = [
  { id: 'fiveTonnes', label: '5 Tonnes', slug: '5-tonnes' },
  { id: 'partsTruck', label: 'Parts Truck', slug: 'parts-truck' },
  { id: 'midSizeBox', label: 'Mid-Size Box Trucks', slug: 'mid-size-box-trucks' },
  { id: 'vans', label: 'Vans / Minivans', slug: 'vans-minivans' },
  { id: 'trailers', label: 'Trailers', slug: 'trailers' },
  { id: 'tractors', label: 'Tractors', slug: 'tractors' },
  { id: 'forklifts', label: 'Forklifts', slug: 'forklifts' },
  { id: 'skidsteer', label: 'Skid-steers', slug: 'skidsteer' },
];

export const CATEGORY_ID_SET = new Set(VEHICLE_CATEGORIES.map((c) => c.id));
export const CATEGORY_BY_SLUG = Object.fromEntries(VEHICLE_CATEGORIES.map((c) => [c.slug, c]));

export function getVehicleCategoryId(truck) {
  const explicit = truck?.category;
  if (explicit && CATEGORY_ID_SET.has(explicit)) return explicit;

  const hay = [
    truck?.vehicle_type,
    truck?.folder,
    truck?.name,
    truck?.make,
    truck?.model,
  ].filter(Boolean).join(' ').toLowerCase();

  if (hay.includes('forklift')) return 'forklifts';
  if (hay.includes('tractor')) return 'tractors';
  if (hay.includes('trailer')) return 'trailers';
  if (hay.includes('parts truck') || hay.includes('parts-truck') || hay.includes('part truck')) return 'partsTruck';
  if (hay.includes('skidsteer') || hay.includes('skid steer')) return 'skidsteer';
  if (hay.includes('van') || hay.includes('minivan')) return 'vans';
  if (hay.includes('5 tonnes') || hay.includes('5 tonne') || hay.includes('5 ton')) return 'fiveTonnes';
  if (hay.includes('box')) return 'midSizeBox';

  const type = String(truck?.vehicle_type || '').toLowerCase();
  if (type.includes('5 tonnes')) return 'fiveTonnes';
  if (type.includes('mid') && type.includes('box')) return 'midSizeBox';
  if (type.includes('van')) return 'vans';
  if (type.includes('trailer')) return 'trailers';
  if (type.includes('tractor')) return 'tractors';
  if (type.includes('forklift')) return 'forklifts';
  if (type.includes('skidsteer') || type.includes('skid steer')) return 'skidsteer';
  if (type.includes('parts truck') || type.includes('parts-truck') || type.includes('part truck')) return 'partsTruck';

  // Default bucket to keep everything visible.
  return 'midSizeBox';
}
